module.exports = __webpack_public_path__ + "static/media/mail.f24d9e81.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mail.png
// module id = 210
// module chunks = 0